import axios from 'axios'

const API_DOMAIN = process.env.VUE_APP_ISR_DOWNLOAD_SERVICE
/* const ERROR_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  TOO_MANY_REQUESTS: 429,

  // SERVER ERROR
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502
} */

/*** Create a custom instance of axios ***/
const http = axios.create({
  baseURL: `${API_DOMAIN}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
})

/*** Add interceptor to modify request config ***/
http.interceptors.request.use(async config => {
  if (config.data instanceof FormData) {
    config.headers = {
      ...config.headers,
      'Content-Type': 'multipart/form-data'
    }
  }

  return config
})

/*** Add global error handling ***/
http.interceptors.response.use(null, error => {
  if (error.response) {
    switch (error.response.status) {
      /* case ERROR_CODES.UNAUTHORIZED:
        return handleUnauthorizedError(error);
      case ERROR_CODES.NOT_FOUND:
        return handleNotFoundError(error);
      case ERROR_CODES.BAD_REQUEST:
        return handleBadRequestError(error); */

      default:
        console.error('Unexpected Error:', error.response.data)
        return Promise.reject(error)
    }
  }
})

export default {
  get: http.get,
  post: http.post,
  put: http.put,
  delete: http.delete
}
